export const baseURL= 
//'http://192.168.29.251:9998/'
 
  "https://api.rndsan.com/"



  

export const baseURL2="https://api.rndsan.com"

//user endpoint
export const user={
    user_add:baseURL+"adminweb/insert",
    user_List:baseURL+"adminweb/getcommonuser",
    user_category:baseURL+"api/category/getcategory",


    user_category_assign:baseURL+"assigncategory",
    user_otp:baseURL+"adminweb/send-otp",
    // userVerify_otp:baseURL+"adminweb/verify-otp-and-create",
}
export const menu={
    get_menu:baseURL+"adminweb/menubar/get-menu",
    insert_New:baseURL+"api/category/insert"
}

//all user endpoint
export const Alluser={
    admin:baseURL+"adminweb/insert",
    agent:baseURL+"adminweb/getcommonuser",
    doctor:baseURL+"adminweb/doctors/getdoctors",
    hospital:baseURL+"adminweb/hospitals/get-all-hospital",
    diagnostic:baseURL+"adminweb/diagnostic-centers/get-all-diagnostic-centers",
    editDoctor:baseURL+'adminweb/doctors/update',
    employee:baseURL+"adminweb/employee/getemployees",
    patient:baseURL+"adminweb/patient/getpatients",
    userRoleDetais:baseURL+"adminweb/sell/commonuser-category/user-categories",
    shopOwner:baseURL+"adminweb/shop/shop-details",
    doctorAddChamber:baseURL+'adminweb/doctors/add-new-chamber-for-doctor',
    doctorlinkedChamberEdit:baseURL+'adminweb/doctors/update-chamber-for-doctor',
    doctorlinkedChamberRemove:baseURL+'adminweb/doctors/remove-doctor-chamber?doctorChamberMappingId=',
    getPatientById:baseURL+'adminweb/patient/get-patient-by-id/',
    getAudioMeter:baseURL+'adminweb/audiometers/get-all-audiometers',
    updatePatient:baseURL+'adminweb/patient/update-patient-data/',
    seniorMarketingExecutive:baseURL+'adminweb/employee/get-all-employees-role-one',
    merketingExecutivePincodeAdd:baseURL+'adminweb/employee/assign-pincode',
    merketingExecutivePincodeLinked:baseURL+'adminweb/employee/assigned-pincodes/',
    allDoctorVisitReoprtByME:baseURL+'adminweb/marketing-work/get-all-doctor-visit-reports'
}

//category endpoint
export const category={
    category_add:baseURL+"adminweb/product/category/insert",
    category_List:baseURL+"adminweb/product/category/gecategory",
    updateCategory_toggle:baseURL+"adminweb/product/category/toggleStatus",
    updateCategory_status:baseURL+"adminweb/product/category/onlineStatus",
    updateCategory_name:baseURL+"adminweb/product/category/updatecategoryById"
}

//Subcategory endpoint
export const subcategory={
    subcategory_add:baseURL+"adminweb/product/subcategory/insert",
    subcategory_List:baseURL+"adminweb/product/subcategory/getsubcategory",
    updateSubCategory_toggle:baseURL+"adminweb/product/subcategory/toggleStatus",
    updateSubCategory_status:baseURL+"adminweb/product/subcategory/onlineStatus",
    updateSubCategory_name:baseURL+"adminweb/product/subcategory/updatesubcategoryById",
    
}

//Product endpoint
export const product={
    product_add:baseURL+"adminweb/product/insert",
    product_List:baseURL+"adminweb/product/getproducts",
    updateProduct_toggle:baseURL+"adminweb/product/toggleStatus",
    updateProduct_status:baseURL+"adminweb/product/onlineStatus",
    updateProduct:baseURL+"adminweb/product/updateProductByid",
    bookingTypes:baseURL+'adminweb/booking-types/get-all-bookingtype',
    allAudiometers:baseURL+'adminweb/audiometers/get-all-audiometers',
    audiometerById:baseURL+'adminweb/audiometers/get-audiometers-byId/',
    createAudiometer:baseURL+'adminweb/audiometers',
    getAllProductReferrals:baseURL+'adminweb/patient-referrals/get-all-product-referrals'
}

//service endpoint
export const service={
    service_add:baseURL+"adminweb/services/insert",
    service_list:baseURL+"adminweb/services/getservices",
    updateServiceToggle_api:baseURL+"adminweb/services/toggle-status",
    updateServiceOnline_status:baseURL+"adminweb/services/toggle-online-status",
    updateServiceData_Api:baseURL+"adminweb/services/update",
    allBookedTests:baseURL+'adminweb/patient/get-allbooked-test',
    getAllRefferedPersons:baseURL+'adminweb/patient/temp/referrals/',
    confirmReferralOnTest:baseURL+'adminweb/patient-referrals/assign',
    getAllProductReferrals:baseURL+'adminweb/patient-referrals/get-all-service-referrals'
}

//vendor endpoint
export const vendor={
    // vendor_add:baseURL+"assigncategory",
    vendor_list:baseURL+"adminweb/vendors/getvendors",
}

//gst endpoint
export const gst={
    get_gst:baseURL+"adminweb/gst/getgst",
    gst_Add:baseURL+"adminweb/gst/insert",
}

//holiday endpoint
export const holiday={
    get_holiday:baseURL+"adminweb/holiday/getholidays",
    holiday_Add:baseURL+"adminweb/gst/insert",
}

//login endpoint
export const login={
    loginApi:baseURL+"adminweb/admin/login",
    LOGOUT_API:baseURL+"adminweb/admin/logout",
    profileApi:baseURL+'adminweb/admin/profile',
    forgetPassword:baseURL+'adminweb/admin/forgot-password',
    resetPassword:baseURL+'adminweb/admin/reset-password'
}

//Employee endpoint
export const employeeCreate={
    employeeRole:baseURL+"adminweb/employee/role/insert",
    get_employeeRole:baseURL+"adminweb/employee/role/employee-roles",
    employeeAssign:baseURL+"adminweb/employee/employee-role-assign",
    getRegionalManager:baseURL+"adminweb/employee/regional-managers",
    getMarketingExecutive:baseURL+"adminweb/employee/marketing-executive",
    teamCreate:baseURL+"adminweb/teams/create",
    employeePayRole:baseURL+"adminweb/employee/payroll/insert",
    employeePayroleList:baseURL+'adminweb/employee/payroll/get',
    employeePermission:baseURL+'adminweb/employee/permissions',
    getTeamList:baseURL+'adminweb/teams/get-team-list',
    storeUpdate:baseURL+'adminweb/store/update-store-data',
    employeeWalletAdd:baseURL+'/adminweb/employee/add-money'
}

//profile endpoint
export const profile={
    get_PeofileApi:baseURL+"adminweb/admin/profile",
    update_PeofileApi:baseURL+"adminweb/admin/update",
}

//purchase bill endpoint
export const purchase={
    purchaseBillApi:baseURL+"adminweb/purchase/insert",
    purchaseBillListApi:baseURL+"adminweb/purchase/getpurchase",
    allProductAvailableToSell:baseURL+'adminweb/purchase/get-all-products-available-me-to-sell'
}

//sell bill endpoint
export const sell={
    sellBillApi:baseURL+"adminweb/sell/insert",
    sellBillListApi:baseURL+"adminweb/sell/getsell",
}

//patient and shopowner user endpoint
export const userList_sell={
    userListSellApi:baseURL+"adminweb/getPatientsAndStoreOwners",
}

//store type endpoint
export const store_type={
    storeType:baseURL+"adminweb/store/store-details",
    storeAll:baseURL+"adminweb/store/store-types",
    getStoreExpenditure:baseURL+'adminweb/store/get-all-store-expenditure'
}

//shop type endpoint
export const shop_type={
    shopType:baseURL+"adminweb/shop/shop-details",
}

//work asign endpoint
export const WorkAssign={
    WorkAssignApi:baseURL+"adminweb/work/insert",
    getRMAssignedWork:baseURL+"adminweb/marketing-work/get-assigned-work-from-admin"
}

//employee work asign endpoint
export const WorkAssignEmployee={
    RMWorkAssignApi:baseURL+"adminweb/marketing-work/assign",
    DoctorsChemberApi:baseURL+"adminweb/doctors",
}

//Expenditures endpoint
export const Expenditures={
    ExpendituresApi:baseURL+"adminweb/daily-expenditures/all",
}

//review question endpoint
export const review={
    reviewQuestionAdd:baseURL+"adminweb/review-questions/create",
    reviewQuestionGet:baseURL+"adminweb/review-questions/details",
}

//Order endpoint
export const Order={
    OrderListApi:baseURL+"adminweb/store/orders",
    OrderApprovedApi:baseURL+"adminweb/store",

}
//PayRoll endpoint
export const PayRoll={
    PayRollApi:baseURL+"adminweb/doctors/comission-details",
    doctorPayRollPaymentApi:baseURL+"adminweb/doctors/add-payment",
    doctorPayRollPaymentHistoryApi:baseURL+"adminweb/doctors/payment-history",
    employeePayrollAll:baseURL+'adminweb/employee/payroll/bulk-insert',
    doctorCommissionById:baseURL+'adminweb/doctors/doctor/',
 
}

export const checkouts={
    getCheckouts: baseURL + "adminweb/checkout/checkout-history",
     getStoreCheckouts: baseURL + "adminweb/store/orders",
    confirmCheckout: baseURL +'adminweb/checkout',
    
    
    getServiceBoy:baseURL+"adminweb/employee/service-person",
    addServiceBoy:baseURL+"adminweb/service-products/assign-service-person",
    dispatchCheckout:baseURL+"adminweb/checkout/dispatch",
     getMedicalTechnicianApi:baseURL+"adminweb/employee/medical-technician/store/1",
}

export const serviceRequest={
    getServiceRequest:baseURL+'adminweb/service-products/getservice-requests',
    assignServicePersonApi:baseURL+'adminweb/service-products/assign-service-person',
    getCustomizedBooking:baseURL+'adminweb/customized-requests/get-all',
    assignCustomizeBookingApi:baseURL+'adminweb/service-products/assign-customized-request',
    getServiceReminderList:baseURL+'adminweb/service-schedules/get-all',
    assignCallingPerson:baseURL+'adminweb/service-schedules/assign-calling-person',
    getServiceReminderCallingPerson:baseURL+'adminweb/service-schedules/task-assigned-for-calling-person',
    getServiceReminderCallingPersonInProgress:baseURL+'adminweb/service-schedules/inprogress-task-for-calling-person',
    updateServiceReminderFollowup:baseURL+'adminweb/service-schedules/updateAssignmentData',
    markCompleteServiceReminder:baseURL+'adminweb/service-schedules/markCompleted',
    assignServiceBoyReminder:baseURL+'adminweb/service-schedules/'


}


export const courier={
    addCourier:baseURL+'adminweb/courier-services/create',
    getCouriers:baseURL+'adminweb/courier-services/get-courierservices',
    editCourier:baseURL+'adminweb/courier-services/update-courierservices',
    craeteDelivery:baseURL+'adminweb/deliveries/create'
}

export const userExtra={
    getAgents:baseURL+'adminweb/agent/getagents'
}

export const empLeave={
    getLeaveTypes:baseURL+'adminweb/leaves/get-all-leave-type',
    getAvailableLeaves:baseURL+'adminweb/leaves/get-all-active-leave-type',
    employeeLeaveApply:baseURL+'adminweb/leaves/apply',
    getAllLeaveByEmployee:baseURL+'adminweb/leaves/get-all-leave-applied-by-employee',
    approveLeave:baseURL+'adminweb/leaves/update-status',
    monthWiseLeave:baseURL+'adminweb/leaves/get-month-wise-leave-details',
    getStoreWallets:baseURL+'adminweb/store/balances-with-history',
    addStoreBalanceWallet:baseURL+'adminweb/store/add-money-to-store-wallet',

}

export const customizeRequest={
    getRequestData:baseURL+'adminweb/customized-requests/customized-request-data/1'
}

export const report={
    getIncomeReport:baseURL+'adminweb/income-reports/get-by-sell',
    expenditureTotal:baseURL+'adminweb/expenditure-reports/get-total-expenditure',
    storeWalletPayExpenditure:baseURL+'adminweb/expenditure-reports/by-paying-wallet-balance-to-stores',
    employeeLocationReportById:baseURL+'adminweb/employee-locations/report?employeeId='
    
}

export const  support ={
    supportRequest:baseURL+'adminweb/support/get-support-request-from-users',
    getSupportChat:baseURL+'adminweb/support/support/chat/',
    replyToSupport:baseURL+'adminweb/support/reply'
}


export const availabilityDate={
    getAvailability:baseURL+'adminweb/patient/fetch-all-availability',
    setNewAvailability:baseURL+'adminweb/patient/set-availability'
}

export const  test={
  bookTest:baseURL+'adminweb/patient/update-patient-data/',
  getAllBooked:baseURL+'adminweb/patient/get-allbooked-test'
}